<template>
  <Modal v-model="modalValue" title="编辑" width="800" @on-cancel="modalCancel">
    <Row>
      <Col span="20" offset="1">
        <Form ref="addForm" :model="form" :rules="rules" :label-width="100">
          <FormItem label="联系人" prop="contact_name">
            <Input placeholder="请输入联系人" v-model="form.contact_name"></Input>
          </FormItem>
          <FormItem label="联系电话" prop="contact_mobile">
            <Input placeholder="请输入联系电话" v-model="form.contact_mobile"></Input>
          </FormItem>
          <FormItem
            v-for="(item, index) in list"
            :key="index"
            :class="item.required ? 'ivu-form-item-required' : ''"
            :label="item.label"
          >
            <!-- 输入框 -->
            <template v-if="item.type == 'input'">
              <Input
                v-model="item.value"
                :type="item.options.type"
                :disabled="item.options.disabled"
                :placeholder="item.options.placeholder"
              ></Input>
            </template>
            <!-- 文本框 -->
            <template v-if="item.type == 'textarea'">
              <Input
                type="textarea"
                v-model="item.value"
                :disabled="item.options.disabled"
                :placeholder="item.options.placeholder"
              ></Input>
            </template>
            <!-- 下拉框 -->
            <template v-if="item.type == 'select'">
              <Select v-model="item.value" :disabled="item.options.disabled" :placeholder="item.options.placeholder">
                <Option
                  v-for="(citem, cindex) in item.options.options"
                  :value="citem.value"
                  :label="citem.label"
                  :key="cindex"
                ></Option>
              </Select>
            </template>
            <!-- 单选 -->
            <template v-if="item.type == 'radio'">
              <RadioGroup v-model="item.value">
                <Radio :label="citem.value" v-for="(citem, cindex) in item.options.options" :key="cindex">
                  {{ citem.label }}
                </Radio>
              </RadioGroup>
            </template>
            <!-- 多选 -->
            <template v-if="item.type == 'checkbox'">
              <CheckboxGroup v-model="item.value">
                <Checkbox :label="citem.value" v-for="(citem, cindex) in item.options.options" :key="cindex">
                  {{ citem.label }}
                </Checkbox>
              </CheckboxGroup>
            </template>
            <!-- 时间年月日 -->
            <template v-if="item.type == 'date'">
              <Date-picker
                type="date"
                style="width: 100%"
                v-model="item.value"
                :disabled="item.options.disabled"
                :placeholder="item.options.placeholder"
              ></Date-picker>
            </template>
            <!-- 时间时分秒 -->
            <template v-if="item.type == 'time'">
              <Date-picker
                type="datetime"
                style="width: 100%"
                v-model="item.value"
                :disabled="item.options.disabled"
                :placeholder="item.options.placeholder"
              ></Date-picker>
            </template>

            <!-- 文件上传 -->
            <template v-if="item.type == 'uploadFile' || item.type == 'uploadImg'">
              <div class="upload-wrap">
                <div class="look-img" v-for="(citem, cindex) in item.value" :key="cindex">
                  <template v-if="item.type == 'uploadImg'">
                    <img :src="citem.url" style="width: 100%" />
                    <div class="demo-upload-list-cover">
                      <Icon type="ios-eye-outline" @click.native="lookFile(index, cindex)"></Icon>
                      <Icon type="ios-trash-outline" @click.native="deleteFile(index, cindex)"></Icon>
                    </div>
                  </template>
                  <template v-else>
                    <a @click="lookFile(index, cindex)">查看</a>
                    <a style="margin-left: 5px; color: #ed4014" @click="deleteFile(index, cindex)">删除</a>
                  </template>
                </div>
                <upload-file-one
                  :type="item.type == 'uploadImg' ? 'img' : 'file'"
                  :noPreview="true"
                  @on-all="uploadChange($event, index)"
                  tips=""
                ></upload-file-one>
              </div>
            </template>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <div slot="footer">
      <Button @click="modalCancel">取消</Button>
      <Button :loading="btnLoading" type="primary" @click="modalConfirm">确认</Button>
    </div>
  </Modal>
</template>

<script>
  import _ from 'lodash'
  import * as apiActivities from '@/api/activity/activity'
  import uploadFileOne from '@/components/upload-custom/upload-file-one.vue'
  export default {
    name: 'edit-user',
    components: {
      uploadFileOne,
    },
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      isEdit: {
        type: Boolean,
        default: false,
      },
      id: {
        type: [String, Number],
        default: '',
      },
    },
    data() {
      return {
        btnLoading: false,
        form: {
          contact_name: '',
          contact_mobile: '',
        },
        list: [],
        rules: {
          contact_name: [{ required: true, message: '联系人不能为空', trigger: 'blur' }],
          contact_mobile: [{ required: true, message: '联系电话不能为空', trigger: 'blur' }],
        },
      }
    },
    methods: {
      // 获取详情
      getDetail() {
        apiActivities.apiActivitiesSignDetail(this.id).then(res => {
          const { data } = res
          this.form.contact_name = data.contact_name
          this.form.contact_mobile = data.contact_mobile
          this.list = data.registration_form
          this.list.forEach((item, index) => {
            if ((item.options.defaultValue && this.list[index].value == '') || !this.list[index].value) {
              this.list[index].value = item.options.defaultValue == '[]' ? [] : item.options.defaultValue
            }
            if (item.rules) {
              this.list[index].required = item.rules[0].required
            }
          })
        })
      },
      // 文件上传成功
      uploadChange(e, index) {
        this.list[index].value.push(e)
      },
      lookFile(index, cindex) {
        let url = this.list[index].value[cindex].url
        let a = document.createElement('a')
        a.href = url
        a.target = '_blank'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      },
      deleteFile(index, cindex) {
        this.list[index].value.splice(cindex, 1)
      },

      // 提交
      modalConfirm() {
        this.$refs['addForm'].validate(valid => {
          if (valid) {
            for (let i = 0; i < this.list.length; i++) {
            let item = this.list[i]
            if (item.required) {
              if (item.value == '' || item.value == null || item.value.length == 0) {
                return this.$Message.error(`${item.label}不能为空`)
              }
            }
          }
            this.btnLoading = true
            apiActivities
              .apiActivitiesSignEdit(this.id, {
                ...this.form,
                registration_form:this.list,
              })
              .then(res => {
                this.$Message.success('编辑成功')
                this.$emit('on-success')
                this.modalCancel()
              })
              .finally(() => this.btnLoading = false)
          }
        })
      },
      modalCancel() {
        this.$refs['addForm'].resetFields()
        this.$nextTick(() => {
          this.modalValue = false
        })
      },
    },
    computed: {
      modalValue: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        },
      },
    },
    watch: {
      value(val) {
        if (val) {
          this.getDetail()
        }
      },
    },
  }
</script>

<style scoped lang="less">
  .upload-wrap {
    display: flex;
  }
  .look-img {
    display: flex;
    margin-right: 10px;
    align-items: center;
    width: 150px;
    height: 150px;
    border: 1px dashed rgba(197, 197, 197, 1);
    text-align: center;
    justify-content: space-evenly;
    position: relative;
    overflow: hidden;
  }

  .demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    text-align: center;
  }

  .look-img:hover .demo-upload-list-cover {
    display: block;
  }

  .demo-upload-list-cover i {
    line-height: 150px;
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }

  .demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }
</style>
